// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';

export default function ThreeStep() {
  const { pathRoot, comUrl } = useContext(AppConfigContext);

  return (
    <Box>
      <Box component="section" className="md:py-[72px] max-md:pt-12 max-md:pb-10 bg-gray-01">
        <Typography
          variant="h3"
          className="relative max-md:ml-4 mb-6 md:px-24 max-md:px-6 z-0 text-center text-[26px] max-md:text-lg font-bold tracking-wide text-rf-navy"
        >
          <Typography
            component="span"
            className="relative before:w-[136px] max-md:before:w-[100px] before:h-[3px] before:absolute before:bottom-[-7px] before:left-0 before:bg-rf-navy before:rounded-sm font-bold text-[26px] max-md:text-lg"
          >
            <Typography
              component="span"
              className="relative pr-2 text-[40px] max-md:text-[32px] font-bold before:absolute before:z-[-1] before:top-[-16px] before:left-[-22px] before: before:w-16 before:h-16 before:rounded-full before:bg-white"
            >
              3
            </Typography>
            ステップで
          </Typography>
          リノベの魅力を解説
        </Typography>
        <Typography component="p" className="mb-14 max-md:mb-8 text-center text-lg max-md:text-sm">
          エリアも内装もかなえるリノベという選択肢
        </Typography>
        <picture>
          <source srcSet={`${pathRoot}assets/images/detail/pc/main.webp`} media="(min-width: 768px)" type="image/jpg" />
          <img
            src={`${pathRoot}assets/images/detail/sp/main.webp`}
            alt='諦めなくてよかった。リノベで叶えた”ここ"で暮らす毎日'
            width="37"
            height="17"
            className="m-auto mb-16 max-md:mb-10 w-full max-h-[414px]"
          />
        </picture>
        <Box className="md:max-w-7xl md:w-full md:mx-auto md:px-24">
          <Box className="flex max-md:flex-col justify-between max-md:justify-center gap-10 mb-10 max-md:mx-5">
            <Box className="relative max-md:mx-auto	pt-11 max-md:pt-7 px-8 max-md:px-3 pb-14 max-md:pb-7 max-w-[530px] xl:w-[530px] w-2/4 max-md:w-full bg-white rounded-lg">
              <picture>
                <source
                  srcSet={`${pathRoot}assets/images/detail/pc/step1.svg`}
                  media="(min-width: 768px)"
                  type="image/jpg"
                />
                <img
                  src={`${pathRoot}assets/images/detail/sp/step1.svg`}
                  alt="step1"
                  width="72"
                  height="28"
                  className="w-[94px] max-md:w-[72px] h-[45px] max-md:h-7 absolute top-[-12px] left-[32px] max-md:left-7"
                />
              </picture>
              <Typography
                component="p"
                className="mb-5 max-md:mb-2 max-md:pl-1 text-xl max-md:text-lg font-bold tracking-wider text-rf-navy"
              >
                検討物件が増える
              </Typography>
              <img
                src={`${pathRoot}assets/images/detail/common/step1_b.jpg`}
                width="93"
                height="57"
                alt="物件価格を抑えて検討物件を増やす"
                className="w-full max-md:max-w-[466px] xl:min-w-[466px]"
              />
              <Typography
                component="p"
                className="absolute text-xs max-md:text-2xs mt-4 max-md:mt-2 right-8 max-md:right-3 bottom-4 max-md:bottom-3"
              >
                ※画像は一例です
              </Typography>
            </Box>
            <Box className="relative pt-11 max-md:mx-auto max-md:pt-7 px-8 max-md:px-3 pb-8 max-md:pb-3 max-w-[530px] xl:w-[530px] w-2/4 max-md:w-full bg-white rounded-lg">
              <picture>
                <source
                  srcSet={`${pathRoot}assets/images/detail/pc/step2.svg`}
                  media="(min-width: 768px)"
                  type="image/jpg"
                />
                <img
                  src={`${pathRoot}assets/images/detail/sp/step2.svg`}
                  alt="step2"
                  width="72"
                  height="28"
                  className="w-[94px] max-md:w-[72px] h-[45px] max-md:h-7 absolute top-[-12px] left-[32px] max-md:left-7"
                />
              </picture>
              <Typography
                component="p"
                className="mb-5 max-md:mb-2 max-md:pl-1 text-xl max-md:text-lg font-bold tracking-wider text-rf-navy"
              >
                プロのデザイナーと共に物件をあなた仕様にする
              </Typography>
              <img
                src={`${pathRoot}assets/images/detail/common/step2_b.webp`}
                alt='"プロのデザイナーと共に物件をあなた仕様に'
                width="93"
                height="57"
                className="w-full max-md:max-w-[466px] xl:min-w-[466px]"
              />
            </Box>
          </Box>
          <Box className="flex max-md:block justify-between gap-10 max-md:mx-5">
            <Box className="relative pt-11 max-md:mx-auto max-md:pt-7 px-8 max-md:px-3 pb-8 max-md:pb-3 max-w-[530px] xl:w-[530px] w-2/4 max-md:w-full bg-white rounded-lg">
              <picture>
                <source
                  srcSet={`${pathRoot}assets/images/detail/pc/step3.svg`}
                  media="(min-width: 768px)"
                  type="image/jpg"
                />
                <img
                  src={`${pathRoot}assets/images/detail/sp/step3.svg`}
                  alt="step3"
                  width="72"
                  height="28"
                  className="w-[94px] max-md:w-[72px] h-[45px] max-md:h-7 absolute top-[-12px] left-[32px] max-md:left-7"
                />
              </picture>
              <Typography
                component="p"
                className="mb-5 max-md:mb-2 max-md:pl-1 text-xl max-md:text-lg font-bold tracking-wider text-rf-navy"
              >
                総予算を変えずに理想を実現する
              </Typography>
              <img
                src={`${pathRoot}assets/images/detail/common/step3_b.jpg`}
                alt="プロのデザイナーと共に物件をあなた仕様に"
                width="93"
                height="57"
                className="w-full max-md:max-w-[466px] xl:min-w-[466px]"
              />
            </Box>
            <Box className="relative flex md:flex-col justify-center max-md:mt-8 w-2/4 max-md:w-full">
              <img
                src={`${pathRoot}assets/images/detail/common/cta_catchphrase.png`}
                alt="低価格物件+リノベで住まいが叶う！"
                width="100"
                height="45"
                className=" w-[530px] max-md:w-[335px]"
              />
            </Box>
          </Box>
        </Box>
        <Box className="flex max-md:flex-col justify-center md:gap-x-14 max-md:gap-y-8 mt-[72px] max-md:mt-12 max-md:mx-5">
          <Box className="text-center">
            <Typography component="p" className="text-xl max-md:text-base md:leading-8">
              リノベーションいいかも…?と思った、
            </Typography>
            <Typography component="p" className="text-xl max-md:text-base md:leading-8 font-bold">
              そんなあなた
            </Typography>
            <Typography component="p" className="text-xl max-md:text-base md:leading-8">
              プロに無料で相談できます
            </Typography>
          </Box>
          <Box>
            <Typography component="p" className="mb-2 max-md:mb-2 text-lg text-rf-navy font-bold text-center">
              <Typography
                component="span"
                className="relative
            after:absolute after:left-[-27px] after:bottom-[8px] after:bg-rf-navy after:transform after:rotate-[50deg] after:w-5 after:h-[1px] after:rounded-sm
            before:absolute before:right-[-26px] before:bottom-[8px] before:bg-rf-navy before:transform before:-rotate-[50deg] before:w-5 before:h-[1px] before:rounded-sm"
              >
                簡単１分
              </Typography>
            </Typography>
            <Link href={`${comUrl}lp/inquiry_check/`} className="group no-underline">
              <Box className="rf-btn-lg-spMax relative">
                無料相談はこちら
                <img
                  src={`${pathRoot}assets/images/common/ArrowForwardRoundedIcon_black.svg`}
                  alt="arrow"
                  className="md:opacity-0  group-hover:opacity-100 absolute top-[18px] right-[20px] w-5 transition delay-150"
                />
              </Box>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
